import { render, staticRenderFns } from "./copyInput.vue?vue&type=template&id=603f681d&scoped=true"
import script from "./copyInput.vue?vue&type=script&lang=js"
export * from "./copyInput.vue?vue&type=script&lang=js"
import style0 from "./copyInput.vue?vue&type=style&index=0&id=603f681d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603f681d",
  null
  
)

export default component.exports